module.exports = function getResource(label, vars = []) {
    let resources = {
        headText: 'Clavardez avec le service à la clientèle',
        available: 'Disponible',
        unavailable: 'Clavardage non disponible',
        inHours: 'Tous les agents sont occupés',
        offline: 'Nous ne sommes pas en ligne présentement',
        headTextAlt: 'Clavardage avec le service à la clientèle'
    };

    return resources[label];
};
